<template>
	<div class="relative w-full h-full" id="section_the_serum">
		<!-- menu -->
		<div class="page2-menu absolute flex flex-row items-center top-[80px] w-full z-[20] px-[25px] gap-[8px]" ref="subMenuEl">
			<img alt="" src="images/1x_images/section2/menu-serum.png" srcset="images/2x_images/section2/menu-serum.png 2x" class="button nav relative" @click="scrollTo(0)" />
			<div class="flex justify-evenly items-center w-full z-[99] bg-white opacity-[0.8] rounded-[10px] h-[54.5px]" ref="menuNavEl">
				<div class="button nav text-[19px]" @click="scrollTo(2)">OVERVIEW</div>
				<div class="button nav text-[19px]" @click="scrollTo(3)">KEY INGREDIENTS</div>
				<div class="button nav text-[19px]" @click="scrollTo(4)">KEY TECHNOLOGIES</div>
				<div class="button nav text-[19px]" @click="scrollTo(5)">RESULTS</div>
				<div class="button nav text-[19px]" @click="scrollTo(6)">HOW TO USE</div>
				<div class="button nav text-[19px]" @click="scrollTo(7)">REGIMEN</div>
			</div>
			<!-- <div class="flex justify-evenly items-center w-full z-[99] bg-white rounded-[10px] h-[54.5px] ml-[8px]" ref="menuNavEl">
				<img alt="" src="images/1x_images/menu-overview.png" srcset="images/2x_images/menu-overview.png 2x" class="button nav" @click="goTo(1)" />
				<img alt="" src="images/1x_images/menu-keytech.png" srcset="images/2x_images/menu-keytech.png 2x" class="button nav" @click="goTo(2)" />
				<img alt="" src="images/1x_images/menu-results.png" srcset="images/2x_images/menu-results.png 2x" class="button nav" @click="goTo(3)" />
				<img alt="" src="images/1x_images/menu-howtouse.png" srcset="images/2x_images/menu-howtouse.png 2x" class="button nav" @click="goTo(4)" />
				<img alt="" src="images/1x_images/menu-completeRoutine.png" srcset="images/2x_images/menu-completeRoutine.png 2x" class="button nav" @click="goTo(5)" />
			</div> -->
			<img alt="" src="images/1x_images/menu-indicator.png" srcset="images/2x_images/menu-indicator.png 2x" class="absolute left-0 z-[99] will-change-transform" ref="indicatorEl" />
		</div>
		<!-- pages -->
		<div class="mainDiv2 relative flex z-[10]" @scroll="handleScroll" @touchmove="handleTouchMove">
			<div class="parentDiv2"><Page1 ref="page1El" class="z-[21]" /></div>
			<div class="parentDiv2"><Page2 ref="page2El" class="z-[20]" /></div>
			<div class="parentDiv2"><Page3 ref="page3El" class="z-[19]" /></div>
			<div class="parentDiv2"><Page4 ref="page4El" class="z-[18]" /></div>
			<div class="parentDiv2"><Page5 ref="page5El" class="z-[17]" /></div>
			<div class="parentDiv2"><Page6 ref="page6El" class="z-[16]" /></div>
			<div class="parentDiv2"><Page7 ref="page7El" class="z-[15]" /></div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import Page1 from "./page1.vue";
import Page2 from "./page2.vue";
import Page3 from "./page3.vue";
import Page4 from "./page4.vue";
import Page5 from "./page5.vue";
import Page6 from "./page6.vue";
import Page7 from "./page7.vue";
import gsap from "gsap";

export default {
	name: "main-page",
	components: { Page1, Page2, Page3, Page4, Page5, Page6, Page7 },
	data() {
		return {
			thisSection: 2,
			pages: 4,
			currentPage: 1,
			container: null,
			childDivs: null,
			inTransiting: false,
			stopped: true,
			scrollTimer: null,
		};
	},
	methods: {
		start() {},
		stop() {},
		handleTouchMove(e) {
			if (!this.stopped && e.target.closest(".asset-container")) {
				e.preventDefault();
			}
		},
		handleScroll(e) {
			this.stopped = false;

			var scrollAmount = this.container.scrollLeft;

			var calc1 = scrollAmount / 1024;
			var calc2 = Math.floor(calc1);
			var calc3 = calc1 - calc2;

			if (calc3 > 0.5) {
				this.positionIndicator(calc2 + 1);
			} else {
				this.positionIndicator(calc2);
			}

			if (this.scrollTimer) {
				clearTimeout(this.scrollTimer);
			}
			this.scrollTimer = setTimeout(() => {
				this.onScrollStop();
			}, 150);
		},
		onScrollStop() {
			this.stopped = true;
			if (currentSection != this.thisSection) return;

			this.childDivs.forEach((page) => {
				const rect = page.getBoundingClientRect();
				if (Math.floor(Math.abs(rect.left)) <= 10) {
					var nextPage = page.getAttribute("page");
					if (nextPage != this.currentPage) {
						this.stopOthers(this.currentPage);
						this.startPage(nextPage);
						// this.positionIndicator(nextPage - 1);
						this.currentPage = nextPage;
					}
				}
			});
		},
		stopOthers(page) {
			this.$refs[`page${page}El`].stop();
		},
		startPage(page) {
			this.$refs[`page${page}El`].start();
		},
		stopAll() {
			for (var i = 1; i <= 4; i++) {
				this.$refs[`page${i}El`].stop();
			}
			this.currentPage = 1;
		},
		resetScroll() {
			this.scrollTo(1);
			// this.positionIndicator(0);
		},
		scrollTo(page) {
			this.container.scrollTo({ left: 1024 * (page - 1), behavior: "smooth" });
		},
		positionIndicator(index) {
			const el = document.querySelectorAll(".nav")[index];
			const dimension = el.getBoundingClientRect();
			const dimensionWidth = dimension.width / ratioToOriginal;
			const dimensionX = dimension.x / ratioToOriginal;

			var pos = (dimensionWidth - 83) / 2 + dimensionX; //83 is indicator length
			gsap.to(this.$refs.indicatorEl, { x: pos, ease: "none", duration: 0.1 });
		},
		startSection() {
			this.positionIndicator(0);
			this.$refs.page6El.start();
		},
	},
	mounted() {
		// var firstPage = document.querySelectorAll(".childDiv2")[this.currentPage - 1];
		// gsap.set(".childDiv2", { x: -512 });
		// gsap.set(firstPage, { x: 0 });
		this.container = document.querySelector(".mainDiv2");
		this.childDivs = document.querySelectorAll(".childDiv2");
	},
};
</script>

<style></style>
